import Vue from "vue"
import Router from "vue-router"
import store from "@/store"
import { getUserCampaignRequests } from "@/api/users"
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout, other application views are lazyloaded */
import Layout from "@/views/Layout/Layout"
import ContactUs from "@/views/Layout/components/ModalContactUs"

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb(default is true)
    isExternal: false            if true, the item will be an external link
  }
**/

export const constantRoutes = [
  {
    path: "/",
    component: Layout,
    beforeEnter: (to, from, next) => {
      const role = store.getters.roles[0]
      if (role === "freelancer") {
        return next("/liste-videos")
      }
      if (role === "pharmacist" || role === "annonceur") {
        return next("/catalogue-videos")
      }
      if (role === "admin") {
        return next("/liste-videos")
      }
      next()
    },
    hidden: true
  },
  {
    path: "/login",
    component: () => import("@/views/Login/Login"),
    hidden: true,
    name: "login"
  },
  {
    path: "/password/recover",
    name: "recoverPassword",
    component: () => import("@/views/Login/RecoverPassword"),
    hidden: true
  },
  {
    path: "/password/reset/:token",
    hidden: true,
    name: "newPassword",
    component: () => import("@/views/Login/NewPassword")
  }
]

export const asyncRoutes = [
  {
    path: "/mentions-legales",
    component: () => import("@/views/Legal"),
    hidden: true,
    name: "legalTerms",
    roles: ["pharmacist", "annonceur"]
  },
  {
    path: "/",
    component: Layout,
    name: "account",
    meta: {
      title: "Mon compte",
      icon: "user",
      exactPath: "/account",
      roles: ["pharmacist", "freelancer", "annonceur"]
    },
    children: [
      {
        path: "account",
        component: () => import("@/views/Account/Account")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "FreelancerVideosList",
    meta: {
      title: "liste de vidéos",
      icon: "video",
      exactPath: "/liste-videos",
      roles: ["freelancer"]
    },
    children: [
      {
        path: "liste-videos",
        component: () => import("@/views/FreelancerVideosList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminVideosList",
    meta: {
      title: "liste de vidéos",
      icon: "video",
      exactPath: "/liste-videos",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-videos",
        component: () => import("@/views/AdminVideosList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/liste-plannings",
    name: "AdminPlanningsList",
    meta: {
      title: "liste de plannings",
      icon: "calendar",
      exactPath: "/liste-plannings",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-plannings",
        component: () => import("@/views/AdminPlanningsList"),
        children: [
          {
            path: "",
            component: () => import("@/views/AdminPlanningsList/List")
          },
          {
            path: ":id",
            component: () => import("@/views/AdminPlanningsList/Item"),
            name: "AdminPlanningsListItem"
          }
        ]
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminUsersList",
    meta: {
      title: "Liste d'utilisateurs",
      icon: "user",
      exactPath: "/liste-users",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-users",
        component: () => import("@/views/AdminUsersList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminBrandsList",
    meta: {
      title: "Liste de marques",
      icon: "list",
      exactPath: "/liste-marques",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-marques",
        component: () => import("@/views/AdminBrandsList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminThemesList",
    meta: {
      title: "Liste de thématiques",
      icon: "list",
      exactPath: "/liste-thematiques",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-thematiques",
        component: () => import("@/views/AdminThemesList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminSupportsList",
    meta: {
      title: "Liste de supports",
      icon: "list",
      exactPath: "/liste-supports",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-supports",
        component: () => import("@/views/AdminSupportsList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminCompetitorPrice",
    meta: {
      title: "Liste de prix concurrents",
      icon: "list",
      exactPath: "/liste-prices",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-prices",
        component: () => import("@/views/AdminCompetitorPrice")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "Tutorial",
    hidden: true,
    meta: {
      title: "Tutoriel Pharmaflix",
      icon: "list",
      exactPath: "/tutorial",
      roles: ["pharmacist", "annonceur"]
    },
    children: [
      {
        path: "tutorial",
        component: () => import("@/views/Tutorial")
      }
    ]
  },
  {
    path: "/",
    redirect: "catalogue-videos",
    component: Layout,
    name: "videoCatalogue",
    meta: {
      title: "Catalogue de vidéos",
      icon: "video",
      exactPath: "/catalogue-videos",
      roles: ["pharmacist", "annonceur"]
    },
    children: [
      {
        path: "catalogue-videos",
        component: () => import("@/views/VideoCatalog"),
        children: [
          {
            path: "",
            component: () => import("@/views/VideoCatalog/VideoCatalog")
          },
          {
            path: ":id",
            component: () => import("@/views/VideoCatalog/VideoDetails"),
            name: "videoDetails"
          }
        ]
      }
    ]
  },
  {
    path: "/",
    redirect: "/planning",
    component: Layout,
    name: "planning",
    meta: {
      title: "Planning de diffusion",
      icon: "calendar",
      exactPath: "/planning",
      roles: ["pharmacist"]
    },
    children: [
      {
        path: "/planning",
        component: () => import("@/views/Planning"),
        children: [
          {
            path: "",
            component: () => import("@/views/Planning/Planning")
          },
          {
            path: "historique",
            component: () => import("@/views/Planning/PlanningHistory"),
            name: "planningHistory"
          }
        ]
      }
    ]
  },
  {
    path: "/",
    redirect: "/planning",
    component: Layout,
    name: "planning",
    meta: {
      title: "Planning de diffusion",
      icon: "calendar",
      exactPath: "/planning",
      roles: ["annonceur"]
    },
    children: [
      {
        path: "/planning",
        component: () => import("@/views/Grouping/Planning"),
        children: [
          {
            path: "",
            component: () => import("@/views/Grouping/Planning/Planning")
          },
          {
            path: "historique",
            component: () =>
              import("@/views/Grouping/Planning/PlanningHistory"),
            name: "planningHistory"
          }
        ]
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminSupportsTypesList",
    meta: {
      title: "Liste de types de supports",
      icon: "list",
      exactPath: "/liste-supportstypes",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-supportstypes",
        component: () => import("@/views/AdminSupportsTypesList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminSlidersList",
    meta: {
      title: "Liste de sliders",
      icon: "list",
      exactPath: "/liste-sliders",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-sliders",
        component: () => import("@/views/AdminSlidersList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminPacksList",
    meta: {
      title: "Liste de packs",
      icon: "list",
      exactPath: "/liste-packs",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-packs",
        component: () => import("@/views/AdminPacksList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminCampaignsList",
    meta: {
      title: "Liste des campagnes",
      icon: "calendar",
      exactPath: "/liste-campagnes",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-campagnes",
        component: () => import("@/views/AdminCampaignsList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "PharmacistPacksList",
    meta: {
      title: "Liste de packs",
      icon: "list",
      exactPath: "/packs",
      roles: ["pharmacist"]
    },
    children: [
      {
        path: "/packs",
        component: () => import("@/views/PacksList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminSponsoredVideosList",
    meta: {
      title: "Vidéos sponsorisées",
      icon: "video",
      exactPath: "/liste-videos-sponsor",
      roles: ["admin"]
    },
    children: [
      {
        path: "liste-videos-sponsor",
        component: () => import("@/views/AdminSponsoredVideosList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AnnonceurVideosList",
    meta: {
      title: "Vidéos sponsorisées",
      icon: "video",
      exactPath: "/liste-videos",
      roles: ["annonceur"]
    },
    children: [
      {
        path: "liste-videos",
        component: () => import("@/views/AnnonceurVideosList")
      }
    ]
  },
  {
    path: "/",
    redirect: "/campaign",
    component: Layout,
    name: "campaign",
    meta: {
      title: "GÉRER MES CAMPAGNES",
      icon: "",
      exactPath: "/campaign",
      hasSubLinks: true,
      roles: ["annonceur"]
    },
    children: [
      {
        path: "/",
        component: () => import("@/views/Grouping"),
        children: [
          {
            path: "/campaign/reserve",
            component: () =>
              import("@/views/Grouping/components/CampaignSelection"),
            // component: () => import("@/views/Grouping/ReserveAdplace"),
            meta: {
              title: "Mes campagnes",
              icon: "",
              exactPath: "/campaign/reserve",
              roles: ["annonceur"]
            }
          },
          /* {
                              path: "/campaign/reserve/:id",
                              hidden: true,
                              component: () => import("@/views/Grouping/ReserveAdplace"),
                              meta: {
                                title: "Réserver un espace",
                                icon: "",
                                exactPath: "/campaign/reserve",
                                roles: ["annonceur"]
                              }
                            }, */
          {
            path: "/campaign/statistics",
            hidden: true,
            component: () => import("@/views/Grouping/CampaingStatistics"),
            meta: {
              title: "Statistiques des campagnes",
              icon: "",
              exactPath: "/campaign/statistics",
              roles: ["annonceur"]
            }
          }
        ]
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "FreelancerCampaignsList",
    meta: {
      title: "liste de campagnes",
      icon: "video",
      exactPath: "/liste-campagnes",
      roles: ["freelancer"]
    },
    children: [
      {
        path: "liste-campagnes",
        component: () => import("@/views/FreelancerCampaignsList")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "AdminVideoCostPerPlanning",
    meta: {
      title: "Configuration",
      icon: "settings",
      exactPath: "/video-cost-planning",
      roles: ["admin"]
    },
    children: [
      {
        path: "video-cost-planning",
        component: () => import("@/views/VideoCostPerPlanning")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    name: "needHelp",
    meta: {
      title: "Besoin d'aide",
      icon: "question-mark",
      exactPath: "#",
      isExternal: false,
      openModal: true
    },
    children: [{ path: "#", component: ContactUs, name: "ContactUs" }]
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
]

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.afterEach(async to => {
  // const { userInfo } = store.getters
  if (to.name !== "login") {
    const user = store.getters.userInfo
    const isPharmacist = store.getters.roles.includes("pharmacist")
    if (isPharmacist) {
      const { data } = await getUserCampaignRequests(user.id)
      if (data.length > 0) {
        store.dispatch("openModal", {
          name: "campaigns-requests",
          closable: false,
          payload: {
            campaigns: data
          }
        })
      }
    }
  }
})

export default router
